// Group-by control for the todos board / list. Drillcut groups by
// status by default and offers priority, owner, rock, and label as
// alternatives.

import { ChevronDown } from "lucide-react";
import { useState } from "react";
import { DC } from "../sheets/createSlideOver/primitives";

export type GroupByKey = "status" | "priority" | "owner" | "rock" | "label";

const LABELS: Record<GroupByKey, string> = {
  status: "Status",
  priority: "Priority",
  owner: "Owner",
  rock: "Rock",
  label: "Label",
};

export function GroupByControl({
  value,
  onChange,
}: {
  value: GroupByKey;
  onChange: (next: GroupByKey) => void;
}) {
  const [open, setOpen] = useState(false);
  return (
    <div style={{ position: "relative" }}>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        style={{
          display: "inline-flex",
          alignItems: "center",
          gap: 6,
          height: 32,
          padding: "0 12px",
          border: `1px solid ${DC.borderStrong}`,
          background: DC.surface,
          color: DC.greyDeep,
          borderRadius: 6,
          font: "600 11px/1 var(--bsp-font-sans)",
          cursor: "pointer",
        }}
      >
        Group by · <strong style={{ color: DC.primary }}>{LABELS[value]}</strong>
        <ChevronDown size={12} />
      </button>
      {open ? (
        <>
          <div style={{ position: "fixed", inset: 0, zIndex: 30 }} onClick={() => setOpen(false)} aria-hidden />
          <div
            style={{
              position: "absolute",
              top: "calc(100% + 4px)",
              right: 0,
              zIndex: 31,
              background: DC.surface,
              border: `1px solid ${DC.borderStrong}`,
              borderRadius: 6,
              boxShadow: "var(--bsp-shadow-pop)",
              minWidth: 140,
              padding: 4,
            }}
          >
            {(Object.keys(LABELS) as GroupByKey[]).map((k) => (
              <button
                key={k}
                type="button"
                onClick={() => {
                  onChange(k);
                  setOpen(false);
                }}
                style={{
                  display: "block",
                  width: "100%",
                  textAlign: "left",
                  padding: "8px 10px",
                  border: 0,
                  background: k === value ? DC.primaryPale : "transparent",
                  borderRadius: 4,
                  font: "400 13px/1 var(--bsp-font-sans)",
                  color: k === value ? DC.primary : "var(--bsp-fg)",
                  cursor: "pointer",
                }}
              >
                {LABELS[k]}
              </button>
            ))}
          </div>
        </>
      ) : null}
    </div>
  );
}
